module.controller('loginCtrl', ['$http', 'baseURI', '$state', '$rootScope', '$scope', '$stateParams', 'LimitsService', 'Session', 'cacheService', 'authService', 'brandService', '$q', 'localStorageService', 'Transform', '$timeout', '$window', function ($http, baseURI, $state, $rootScope, $scope, $stateParams, LimitsService, Session, cacheService, authService, brandService, $q, localStorageService, Transform, $timeout, $window) {

  $scope.alertError = {};
  $scope.formData = {};

  $scope.displayMessageText = 'Sorry, we were unable to log you in. Please try again in a few minutes.';
  $scope.displayMessage = false;
  $scope.loading = false;
  $scope.registrationText = 'Need to register your card for online access? Click here.';

  if (!$stateParams.brand ) {
    $scope.brand = brandService.getBrand(Session.getBrand());
  } else {
    $scope.brand = brandService.getBrand($stateParams.brand);
  }

  if ($scope.brand.ssoHide) {
    $window.location.href = $scope.brand.homeUrl;
    return;
  }

  $scope.enrollmentLink = "root.join.step1({ joinType: 'enrollment' })";
  $scope.registrationLink = "root.register.step1";

  $scope.hideEnrollmentLink = $scope.brand.hideEnrollmentLink;
  $scope.hideRegistrationLink = $scope.brand.hideRegistrationLink;

  $scope.registrationHyperLink = $scope.brand.registrationHyperLink;
  $scope.enrollmentHyperLink = $scope.brand.enrollmentHyperLink;

  if ($scope.brand.name === 'svm') {
    $scope.registrationText = 'Have a redeem code? Claim your card here';
  }

  $scope.credentials = {
    username: $stateParams.username,
    password: '',
    brand: $scope.brand.name,
    _key: $scope.brand.api_key
  };
  init();
  function init() {
    //clear enrollment local storage info
    localStorageService.remove('orderDataValues');
    localStorageService.remove('cardOrder');
    localStorageService.remove('cardOrderCurrentCard');
    localStorageService.remove('accounts');
    localStorageService.remove('transactions');
  }

  // display error messaging during login
  var handleError = function (error){
    $scope.loading = false;
    $scope.displayMessage = true;

    if (error.status == 428 && error.data.ErrorCode == 166) {
      deviceGet();
      return;
    }

    // 403 errors
    if(error.status === 403 && error.data.ErrorCode){
      switch(error.data.ErrorCode){
        case 150:
          //if the user needs to go through the Jumio KYC process in the dashboard
          cacheService.clear('all');
          $scope.displayMessage = false;
          $q.all([
            authService.checkStatus(),
            authService.getFeatureAccess(),
            LimitsService.update()
          ]).then(function(results){

            // set status and feature access
            authService.setStatusSession(results[0].data);
            authService.setFeatureAccessSession(results[1].data);

            // If signup is complete, direct CH to dashboard
            authService.injectUserToDashboard();

          }).catch(function(err){
            $scope.displayMessageText = 'Sorry we\'re experiencing a temporary issue, please try again later.';
          });
          break;
        case 160:
          $scope.displayMessageText = 'Sorry we\'re experiencing a temporary issue, please try again later.';
          break;
        case 10:
          $scope.displayMessageText = 'Too many login attempts, try again later.';
          break;
        default:
          $scope.displayMessageText = 'Sorry we\'re experiencing a temporary issue, please try again later.';
          break;
      }
    }
    // 502 errors
    if(error.status === 502){
      $scope.displayMessageText = 'Oops ' + $scope.brand.programName + ' is experiencing connectivity issues, please try again in a bit.';
    }
    // 401 and 400 errors
    if(error.status === 401 || error.status === 400){
      $scope.displayMessageText = 'Invalid username or password provided.';
    }
    // 429 errors
    if(error.status === 429) {
      $scope.displayMessageText = "Too Many Requests.";
    }
  };

  $scope.login = function(credentials){
    $scope.loading = true;
    $scope.displayMessage = false;
    $scope.displayMessageText = '';

    credentials.DeviceId = window.visitorId;
    authService.login(credentials, function(error, response){
      if(!response){
        handleError(error);
      } else {
        cacheService.clear('all');
        $scope.displayMessage = false;

        $q.all([
          authService.checkStatus(),
          authService.getFeatureAccess(),
          LimitsService.update()
        ]).then(function(results){
          // set status and feature access
          authService.setStatusSession(results[0].data);
          authService.setFeatureAccessSession(results[1].data);

          if (response.Data.SignupComplete === "true") {
            // If signup is complete, direct CH to dashboard
            authService.injectUserToDashboard();
          } else {
            $state.go('step-1-joinCtrl');
          }
        }).catch(function(err){
          handleError(err);
        });
      }
    });
  };

  var deviceGet = function () {
    var id =  window.visitorId;
    $http({
      url: baseURI + 'cardholder/device/' + id,
      method: 'GET',
      headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
    }).then(function(resp){
      var data = resp.data;

      $scope.loading = false;
      if(data.Success){
        $scope.email = data.Data.Email;
        $scope.phone = data.Data.MobileNumber;

        $scope.formData.email = data.Data.MaskedEmail;
        $scope.formData.phone = data.Data.MaskedMobileNumber;

        devicePost();
      } else {
        $scope.alertError.show = true;
        $scope.alertError.message = 'Please try again later.';
      }
    }).catch(function(error){
      $scope.loading = false;
      $scope.alertError.show = true;
      $scope.alertError.message = 'Please try again later.';
    });
  };

  var devicePost = function () {
    var reqData = {
      DeviceId: window.visitorId,
      DeviceType: 'Web',
    };

    $http({
      url: baseURI + 'cardholder/device',
      method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
      data: Transform.encode(reqData)
    }).then(function(resp){
      $scope.loading = false;
      if(resp.data.Success){
        selectVerificationMethod();
      } else {
        $scope.alertError.show = true;
        $scope.alertError.message = 'Please try again later.';
      }
    }).catch(function(error){
      $scope.loading = false;
      $scope.alertError.show = true;
      $scope.alertError.message = 'Please try again later.';
    });
  };

  var devicePut = function () {
    var reqData = {
      DeviceId: window.visitorId,
    };

    $http({
      url: baseURI + 'cardholder/device',
      method: 'PUT',
      headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
      data: Transform.encode(reqData)
    }).then(function (resp){
      var data = resp.data;

      $scope.loading = false;
      if(data.Success){
        $scope.login($scope.credentials);
      } else {
        $scope.alertError.show = true;
        $scope.alertError.message = 'Please try again later.';
      }
    }).catch(function(error){
      $scope.loading = false;
      $scope.alertError.show = true;
      $scope.alertError.message = 'Please try again later.';
    });
  };

  // Prompt for verification method
  var selectVerificationMethod = function() {
    $scope.formData.verificationMethod = 'email';

    $scope.verificationMethodChange = function(method) {
      $scope.formData.verificationMethod = method;
      $scope.verificationMethodIsPhone = $scope.formData.verificationMethod === 'phone';
      $scope.verificationMethodIsEmail = $scope.formData.verificationMethod === 'email';
    };

    // Default value
    $scope.verificationMethodChange('email');

    // Open the modal
    $scope.showSelectVerificationMethod = true;
  };

  $scope.submitSelectVerificationMethod = function() {
    $scope.showSelectVerificationMethod = false;

    createVerificationCode();
  };

  // Make request for validation Code
  var createVerificationCode = function(){
    $scope.loading = true;

    var reqData = {
      VerificationType: $scope.formData.verificationMethod,
      Contact: $scope.formData.verificationMethod === 'phone' ? $scope.phone : $scope.email,
      _key: $scope.brand.api_key
    };

    $http({
      url: baseURI + 'member/verification',
      method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
      data: Transform.encode(reqData)
    }).then(function(resp){
      $scope.loading = false;
      if(resp.data.Success){
        // Open the modal
        $scope.showValidateEmail = true;
        startCountDown();
      } else {
        $scope.alertError.show = true;
        $scope.alertError.message = 'Sorry, we were unable to verify your email address at this time. Please try again later.';
      }
    }).catch(function(error){
      $scope.loading = false;
      $scope.alertError.show = true;
      $scope.alertError.message = 'Sorry, we were unable to verify your email address at this time. Please try again later.';
    });
  };

  // User is manually submitting code
  $scope.submitCode = function(){
    if(!$scope.formData.VerificationCode){
      $scope.attemptedVerify = true;
      $scope.invalidVerify = false;
    } else {
      $scope.loading = true;
      $scope.attemptedVerify = false;
      var verifiedReq = {
        VerificationType: $scope.formData.verificationMethod,
        Contact: $scope.formData.verificationMethod === 'phone' ? $scope.phone : $scope.email,
        VerificationCode: $scope.formData.VerificationCode
      };

      $http({
        url: baseURI + 'member/verification',
        method: 'PUT',
        headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
        data: Transform.encode(verifiedReq)
      }).then(function (resp){
        var data = resp.data;

        $scope.loading = false;
        $scope.invalidVerify = !data.Success;
        if(data.Success){
          $scope.stopTimeout();
          successVerfication();
        }
      }).catch(function(error){
        $scope.invalidVerify = true;
        $scope.loading = false;
      });
    }
  };

  // User clicks on resend email link
  $scope.reSend = function(){
    $scope.stopTimeout();
    $scope.loadingEmailVerification = true;
    createVerificationCode();
  };

  // Close the modal
  $scope.close = function(){
    if ($scope.showSelectVerificationMethod) {
      $scope.showSelectVerificationMethod = false;
    }
    else {
      $scope.stopTimeout();
      $scope.showValidateEmail = false;
    }
  };

  // User has successfully completed email verification
  var successVerfication = function(){
    $scope.$parent.verifiedEmail = true;
    $scope.loadingEmailVerification = true;
    $scope.showValidateEmail = false;

    devicePut();
  };

  var startCountDown = function() {
    $scope.counter = 1200;

    $scope.onTimeout = function(){
      $scope.counter--;
      if($scope.counter > 1){
        myTimeout = $timeout($scope.onTimeout, 1000);
      } else {
        $scope.stopTimeout();
        $scope.showValidateEmail = false;
      }
    };

    // Create the promise
    var myTimeout = $timeout($scope.onTimeout, 1000);

    // Cancel the promise
    $scope.stopTimeout = function() {
      $timeout.cancel(myTimeout);
    };
  };
}]);
